import { createAsyncThunk } from '@reduxjs/toolkit';
import { albumsService, imageService, shopService, siteService, workerService } from 'services';
import * as Types from 'types';

interface GetAlbumsResponse extends Types.GetAlbumsResponse {
  images: Types.ImageAlbum[];
}
export const getAlbumsImage = createAsyncThunk<
  GetAlbumsResponse,
  Types.GetAlbumsRequest,
  Types.ThunkAPI<Types.GetAlbumsError>
>('albums/thunk/getAlbumsImage', async (params, { rejectWithValue }) => {
  try {
    const {
      data: { images, total },
    } = await albumsService.getAlbums(params);
    return { images: images.map((image) => ({ ...image, isSelected: false })), total };
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const getImageData = createAsyncThunk<
  Types.GetImageResponse,
  Types.GetImageRequest,
  Types.ThunkAPI<Types.GetImageError>
>('albums/thunk/getImage', async (params, { rejectWithValue }) => {
  try {
    const { data } = await imageService.image(params);
    return data;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const deleteImage = createAsyncThunk<
  Types.DeleteImageResponse,
  Types.DeleteImageRequest,
  Types.ThunkAPI<Types.DeleteImageError>
>('albums/thunk/deleteImage', async (dataDelete, { rejectWithValue }) => {
  try {
    const { data } = await albumsService.deleteImage(dataDelete);
    return data;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const getDetailImage = createAsyncThunk<
  Types.GetDetailImageResponse,
  Types.GetDetailImageRequest,
  Types.ThunkAPI<Types.GetDetailImageError>
>('workerStatus/thunk/detailImage', async (params, { rejectWithValue }) => {
  try {
    const { data } = await albumsService.getDetailImage(params);
    return { ...data, image_id: params.image_id };
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addImages = createAsyncThunk<
  Types.AddImageResponse,
  Types.AddImageRequest,
  Types.ThunkAPI<Types.AddImageError>
>('albums/thunk/postImage', async (newData, { rejectWithValue }) => {
  try {
    const { data } = await albumsService.addImages(newData);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const uploadImages = createAsyncThunk<
  Types.UploadImagesResponse,
  Types.UploadImagesRequest,
  Types.ThunkAPI<Types.UploadImagesError>
>('albums/thunk/postUploadImage', async (uploadImage, { rejectWithValue }) => {
  try {
    const { data } = await albumsService.uploadImages(uploadImage);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getWorkerStatus = createAsyncThunk<
  Types.GetWorkerStatusResponse,
  Types.GetWorkerStatusRequest,
  Types.ThunkAPI<Types.GetWorkerStatusError>
>('workerStatus/thunk/getWorkerStatus', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getWorkerStatus(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getCheckSlingTool = createAsyncThunk<
  Types.GetCheckSlingToolResponse,
  Types.GetCheckSlingToolRequest,
  Types.ThunkAPI<Types.GetCheckSlingToolError>
>('checkSlingTool/Thunk/getCheckSlingTool', async (params, { rejectWithValue }) => {
  try {
    const { data } = await shopService.getCheckSlingTool(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getListTestScaffold = createAsyncThunk<
  Types.GetTestScaffoldResponse,
  Types.GetTestScaffoldRequest,
  Types.ThunkAPI<Types.GetTestScaffoldError>
>('testScaffold/Thunk/getTestScaffold', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getListTestScaffold(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getSafetyInstructions = createAsyncThunk<
  Types.GetSafetyInstructionsResponse,
  Types.GetSafetyInstructionsRequest,
  Types.ThunkAPI<Types.GetSafetyInstructionsError>
>('safetyInstructions/Thunk/getSafetyInstructions', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getSafetyInstructions(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getWorkerShift = createAsyncThunk<
  Types.GetWorkerResponse,
  Types.GetWorkerRequest,
  Types.ThunkAPI<Types.GetWorkerError>
>('tableGantt/thunk/getWorkerShift', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getWorkerShift(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const postInformation = createAsyncThunk<
  Types.PostInformationResponse,
  Types.PostInformationRequest,
  Types.ThunkAPI<Types.PostInformationError>
>('post/information', async (paramsData, { rejectWithValue }) => {
  try {
    const { data } = await workerService.postInformation(paramsData);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getStatusApproved = createAsyncThunk<
  Types.GetApprovedResponse,
  Types.GetApprovedRequest,
  Types.ThunkAPI<Types.GetApprovedError>
>('get/ky/approved', async (dataKy, { rejectWithValue }) => {
  try {
    const { data } = await albumsService.getStatusKyApproved(dataKy);
    return { ...data, sites: data.sites.map((d, idx) => ({ ...d, id: idx })) };
  } catch (error) {
    return rejectWithValue(error);
  }
});

// call api latest

export const getSiteShopUserSchedule = createAsyncThunk<
  Types.GetUserSiteShopListResponse,
  Types.GetUserSiteShopListRequest,
  Types.ThunkAPI<Types.GetUserSiteShopListError>
>('/getSiteShopUserSchedule', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getSiteShopList(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getSiteCooperatorListToday = createAsyncThunk<
  Types.GetUserSiteShopListTodayResponse,
  Types.GetUserSiteShopListTodayRequest,
  Types.ThunkAPI<Types.GetUserSiteShopListTodayError>
>('/getSiteShopUserScheduleToday', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getSiteShopListToday(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// 2025/02/25 FJ 3月分反映分 NO32 start
export const getSiteFirstCooperatorListToday = createAsyncThunk<
  Types.GetUserSiteShopListTodayResponse,
  Types.GetUserSiteShopListTodayRequest,
  Types.ThunkAPI<Types.GetUserSiteShopListTodayError>
>('/getSiteFirstCooperatorListToday', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getSiteFirstCooperatorListToday(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 end

export const getKYDataApproveBySiteManage = createAsyncThunk<
  Types.GetKYDataApproveBySiteManageResponse,
  Types.GetKYDataApproveBySiteManageRequest,
  Types.ThunkAPI<Types.GetKYDataApproveBySiteManageError>
>('getKYDataApproveBySiteManage', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getKYDataApproveBySiteManage(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const getTodayFootingCheck = createAsyncThunk<
  Types.TodayFootingcheckResponse,
  Types.TodayFootingcheckParams,
  Types.ThunkAPI<Types.TodayFootingcheckError>
>('getTodayFootingCheck', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getTodayFootingCheck(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 start
export const getTodayFootingCheckGroup = createAsyncThunk<
  Types.TodayFootingcheckResponse,
  Types.TodayFootingcheckGroupParams,
  Types.ThunkAPI<Types.TodayFootingcheckError>
>('getTodayFootingCheckGroup', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getTodayFootingCheckGroup(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 end
export const getTodaySafetyOrder = createAsyncThunk<
  Types.TodaySafetyOrderResponse,
  Types.TodaySafetyOrderParams,
  Types.ThunkAPI<Types.TodaySafetyOrderError>
>('/today_safetyorder', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getTodaySafetyOrder(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 start
export const getTodaySafetyOrderGroup = createAsyncThunk<
  Types.TodaySafetyOrderResponse,
  Types.TodaySafetyOrderGroupParams,
  Types.ThunkAPI<Types.TodaySafetyOrderError>
>('/today_safetyorder/group', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getTodaySafetyOrderGroup(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 end
export const getTodaySlingtool = createAsyncThunk<
  Types.TodaySlingToolResponse,
  Types.TodaySlingToolparams,
  Types.ThunkAPI<Types.TodaySlingToolError>
>('/today_slingtool', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getTodaySlingtool(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 start
export const getTodaySlingtoolGroup = createAsyncThunk<
  Types.TodaySlingToolResponse,
  Types.TodaySlingToolGroupparams,
  Types.ThunkAPI<Types.TodaySlingToolError>
>('/today_slingtool/group', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getTodaySlingtoolGroup(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 end
export const getSiteUserStatus = createAsyncThunk<
  Types.SiteUsersStatusRespon,
  Types.SiteUsersStatusParams,
  Types.ThunkAPI<Types.SiteUsersStatusError>
>('/site/users/status', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getSiteUserStatus(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// 2025/02/25 FJ 3月分反映分 NO32 start
export const getSiteUserGroupStatus = createAsyncThunk<
  Types.SiteUsersStatusRespon,
  Types.SiteUsersGroupStatusParams,
  Types.ThunkAPI<Types.SiteUsersStatusError>
>('/site/users/status/group', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getSiteUserGroupStatus(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 end

export const getPerformance = createAsyncThunk<
  Types.GetPerformanceResponse,
  Types.GetPerformanceRequest,
  Types.ThunkAPI<Types.GetGetPerformanceError>
>('/getPerformance', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getPerformance(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// 2025/02/25 FJ 3月分反映分 NO32 start
export const getPerformanceGroup = createAsyncThunk<
  Types.GetPerformanceResponse,
  Types.GetPerformanceGroupRequest,
  Types.ThunkAPI<Types.GetGetPerformanceError>
>('/getPerformance/group', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getPerformanceGroup(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 end

export const getPerformanceWorkArea = createAsyncThunk<
  Types.GetPerformanceWorkAreaResponse,
  Types.GetPerformanceWorkAreaRequest,
  Types.ThunkAPI<Types.GetGetPerformanceError>
>(' /performance/work_area', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getPerformanceWorkArea(params);
    return { ...data, branch_no: params.branch_no };
  } catch (error) {
    return rejectWithValue(error);
  }
});
// get /Ky

export const getKy = createAsyncThunk<
  Types.GetKyResponse,
  Types.GetKyParams,
  Types.ThunkAPI<Types.GetUserHealthError>
>(' /get/ky', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getKy(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// 2025/02/25 FJ 3月分反映分 NO32 start
export const getKyGroup = createAsyncThunk<
  Types.GetKyResponse,
  Types.GetKyGroupParams,
  Types.ThunkAPI<Types.GetUserHealthError>
>(' /get/ky/group', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getKyGroup(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 end

//user status

export const getUserStatusChart = createAsyncThunk<
  Types.GetUserStatusesResponse,
  Types.GetUserStatusesRequest,
  Types.ThunkAPI<Types.GetUserStatusesError>
>(' /chart', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getUserStatusChart(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getUserHealthCharts = createAsyncThunk<
  Types.GetUserHealthResponse,
  Types.GetUserHealthRequest,
  Types.ThunkAPI<Types.GetUserHealthError>
>(' /chart/health', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getUserHealthChart(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getShopSchedules = createAsyncThunk<
  Types.GetShopScheduleResponse,
  Types.GetShopScheduleRequest,
  Types.ThunkAPI<Types.GetShopScheduleError>
>(' /Shop/Schedules', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getShopSchedules(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
